import { Download, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { canPromptInstall, isStandalone } from '../pwa';

export function InstallBanner() {
  const [visible, setVisible] = useState(
    () => !isStandalone() && sessionStorage.getItem('kidee:install-dismissed') !== '1'
  );
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((value) => value + 1);
    window.addEventListener('kidee:install-available', refresh);
    window.addEventListener('kidee:installed', refresh);
    return () => {
      window.removeEventListener('kidee:install-available', refresh);
      window.removeEventListener('kidee:installed', refresh);
    };
  }, []);
  if (!visible || isStandalone()) return null;
  return (
    <aside className="install-banner">
      <div className="install-banner__icon"><Download size={22} /></div>
      <div>
        <strong>Cài Kidee như một app</strong>
        <p>{canPromptInstall() ? 'Cài nhanh và nhận thông báo trên điện thoại.' : 'Xem hướng dẫn cho iPhone và Android.'}</p>
      </div>
      <Link to="/install" className="button button--small">Cài</Link>
      <button
        type="button"
        className="icon-button"
        aria-label="Ẩn lời mời cài đặt"
        onClick={() => {
          sessionStorage.setItem('kidee:install-dismissed', '1');
          setVisible(false);
        }}
      >
        <X size={18} />
      </button>
    </aside>
  );
}
